import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Menu as MuiMenu,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";

import "./NotificationsMenu.scss";

const NotificationsMenu = ({
  menuController,
  menuHeader,
  menuItems,
  handleSelectItem,
  menuFooter,
  menuPaperClass,
  menuListClass,
  menuFooterClass,
  emptyState,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleControllerClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={`notifications-menu-wrapper`}>
      <div
        aria-controls="custom-menu"
        className={"menu-controller"}
        onClick={handleControllerClick}>
        {menuController}
      </div>
      <MuiMenu
        id="custom-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        classes={{
          paper: `notifications-menu ${menuPaperClass}`,
          list: `notifications-list ${menuListClass}`,
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
        {menuHeader && <div className="notifications-menu-header">{menuHeader}</div>}
        {menuItems.length ? (
          menuItems.map(({ id, content, icon, className, adorment }, index) => (
            <MenuItem
              className={`menu-item d-flex justify-content-between ${className}`}
              onClick={() => {
                handleSelectItem(id);
              }}
              key={index}>
              <div
                onClick={() => {
                  handleClose();
                }}>
                {icon && <ListItemIcon>{icon}</ListItemIcon>}
                <ListItemText>{content}</ListItemText>
              </div>
              {adorment && <>{adorment}</>}
            </MenuItem>
          ))
        ) : (
          <div className="notifications-menu-empty">{emptyState}</div>
        )}
        {menuItems.length > 0 && menuFooter && (
          <div
            className={`menu-title ${menuFooterClass}`}
            onClick={handleClose}>
            {menuFooter}
          </div>
        )}
      </MuiMenu>
    </div>
  );
};

NotificationsMenu.propTypes = {
  menuController: PropTypes.element.isRequired,
  menuHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      content: PropTypes.element,
      icon: PropTypes.element,
      adorment: PropTypes.element,
      className: PropTypes.string,
    })
  ),
  handleSelectItem: PropTypes.func,
  menuFooter: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  menuPaperClass: PropTypes.string,
  menuListClass: PropTypes.string,
  menuFooterClass: PropTypes.string,
  adorment: PropTypes.element,
  emptyState: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default NotificationsMenu;
